module.exports = __webpack_public_path__ + "img/companyIntro19.b5ed0f22.png";